import BraydenTim from "../assets/ProfilePicture/BraydenTim.svg";
import DonnaPaul from "../assets/ProfilePicture/DonnaPaul.svg";
import FlorenceRoss from "../assets/ProfilePicture/FlorenceRoss.svg";
import JessicaRayn from "../assets/ProfilePicture/JessicaRayn.svg";
import MikeRoss from "../assets/ProfilePicture/MikeRoss.svg";

const userList = [
  {
    userName: "donnapaul",
    userId: 3,
    loginTime: "2022-11-21T10:49:58.088+00:00",
    roles: ["Admin"],
    phoneNum: "+15852826892",
    email: "donnapaul@mets.com",
    currentRoleType: "ADMIN",
    firstName: "Donnapaul",
    lastName: "",
    password: "Dp@2023#",
    profilePicture: DonnaPaul,
  },
  {
    userName: "mikeross",
    userId: 3,
    email: "mikeross@mets.com",
    loginTime: "2022-11-21T10:49:58.088+00:00",
    roles: ["Admin"],
    phoneNum: "+15852826892",
    currentRoleType: "ADMIN",
    firstName: "Mikeross",
    lastName: "",
    password: "Mr@2023#",
    profilePicture: MikeRoss,
  },
  {
    userName: "braydentim",
    userId: 3,
    email: "braydentim@mets.com",
    loginTime: "2022-11-21T10:49:58.088+00:00",
    roles: ["Admin"],
    phoneNum: "+15852826892",
    currentRoleType: "ADMIN",
    firstName: "Braydentim",
    lastName: "",
    password: "Bt@2023#",
    profilePicture: BraydenTim,
  },
  {
    userName: "jessicarayn",
    email: "jessicarayn@mets.com",
    userId: 3,
    loginTime: "2022-11-21T10:49:58.088+00:00",
    roles: ["Admin"],
    phoneNum: "+15852826892",
    currentRoleType: "ADMIN",
    firstName: "Jessicarayn",
    lastName: "",
    password: "Jr@2023#",
    profilePicture: JessicaRayn,
  },
  {
    userName: "florenceross",
    email: "florenceross@mets.com",
    userId: 3,
    loginTime: "2022-11-21T10:49:58.088+00:00",
    roles: ["Admin"],
    phoneNum: "+15852826892",
    currentRoleType: "ADMIN",
    firstName: "Florenceross",
    lastName: "",
    password: "Fr@2023",
    profilePicture: FlorenceRoss,
  },
];
export default userList;
